import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { PlusModalData } from "../models";

type PlusModelResponse = {
  savedCardData: {
    num: number;
    creditCardType: string;
    name: string;
    expirationDate: string;
    isRewardsCard: boolean;
    lastFour: string;
    default: boolean;
    cardNickname: string;
  }[];
  enrollmentOptions: {
    promotionName: string;
    description: string;
    price: number;
    months: number;
    isPromotion: boolean;
  }[];
  formattedPlusPrice: number;
  validAddresses: {
    id: number;
    display: string;
    isDefault: boolean;
  }[];
  subscriptionChargeDate?: string;
};

const fetchPlusModalData = async (): Promise<Throwable<PlusModalData>> => {
  try {
    const url = new URL(`/api/plussignup/`, window.location.origin);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json<PlusModelResponse>();

      return {
        isError: false,
        value: {
          ...data,
          savedCardData: data.savedCardData.map((cc) => {
            return {
              ...cc,
              expirationDate: new Date(cc.expirationDate),
            };
          }),
          subscriptionChargeDate: data.subscriptionChargeDate
            ? new Date(data.subscriptionChargeDate)
            : undefined,
        },
      };
    }

    return {
      isError: true,
      error: new Error(
        `Unexpected HTTP ${response.status} getting Plus Modal data`,
      ),
    };
  } catch (error) {
    return {
      isError: true,
      error: toError(error),
    };
  }
};

export default fetchPlusModalData;
